"use client"

import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@mui/material";
import { Shuffle } from "lucide-react";

const CardSelectionDebug = () => {
    const [cardOrder, setCardOrder] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

    const shuffleCards = () => {
        setCardOrder(prevCards => {
            const newCards = [...prevCards];
            // Fisher-Yates shuffle algorithm
            for (let i = newCards.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newCards[i], newCards[j]] = [newCards[j], newCards[i]];
            }
            console.log('Before:', prevCards);
            console.log('After:', newCards);
            return newCards;
        });
    };

    return (
        <div className="flex flex-col items-center p-8 min-h-screen">
            <Button
                variant="contained"
                size="small"
                onClick={shuffleCards}
                className="mb-8"
            >
                <Shuffle className="w-4 h-4 mr-2" />
                Shuffle
            </Button>

            <div className="flex flex-wrap gap-4 max-w-4xl">
                {cardOrder.map((cardId) => (
                    <motion.div
                        key={cardId}
                        layout
                        transition={{
                            layout: {
                                type: "spring",
                                stiffness: 250,
                                damping: 30,
                            }
                        }}
                        style={{
                            width: '100px',
                            height: '140px',
                            backgroundColor: '#3b82f6',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            color: 'white',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }}
                    >
                        {cardId}
                    </motion.div>
                ))}
            </div>

            <div className="mt-8 p-4 bg-gray-100 rounded">
                <p className="font-mono text-sm">
                    Current order: [{cardOrder.join(', ')}]
                </p>
            </div>
        </div>
    );
};

export default CardSelectionDebug;

